import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import PageLoader from '../../@jumbo/components/PageComponents/PageLoader';

const InteractPage = ({ match }) => {
    const requestedUrl = match.url.replace(/\/$/, '');
    return (
        <Suspense fallback={<PageLoader />}>
            <Switch>
                <Redirect exact from={`${requestedUrl}/`} to={`${requestedUrl}/like-page`} />
                <Route path={`${requestedUrl}/like-page`} component={lazy(() => import('./likePage'))} />
                <Route path={`${requestedUrl}/invite-like-page`} component={lazy(() => import('./inviteLikePage'))} />
            </Switch>
        </Suspense>
    );
};

export default InteractPage;
